import { DownloadFileLinkField } from 'domain/shared/artifact/field';

const AcceptanceArtifactStorageFileField = () => (
  <DownloadFileLinkField label="Name" pathSource="path" metadataSource="metadata" />
);

export default AcceptanceArtifactStorageFileField;
